module.exports = __webpack_public_path__ + "img/7.ecea5022.png";